// Forty Thieves. .ai/game-rules.md "Forty Thieves". Single cards only (an explicit rule here; legacy
// only had drag handlers on top cards).
import type { Card, CardKey, GameState, PileRef } from '../types';
import { rankLow } from '../cards';
import { card, dropOnFoundation, liftTopOnly, pileCards, standardFoundationFor, topOf, type VariantRules } from './base';

/** Down by 1 in the SAME suit; an Ace may go on a same-suit 2. */
function buildsOn(c: Card, onto: Card): boolean {
  return c.suit === onto.suit && rankLow(onto.rank) === rankLow(c.rank) + 1;
}

function canLift(s: GameState, pile: PileRef, index: number): boolean {
  if (pile.kind === 'stock') return false;
  return liftTopOnly(s, pile, index);
}

function canDrop(s: GameState, run: readonly CardKey[], target: PileRef): boolean {
  const bottom = run[0];
  if (bottom === undefined || run.length !== 1) return false;
  if (target.kind === 'foundation') return dropOnFoundation(s, run, target.index);
  if (target.kind !== 'tableau') return false;
  const top = topOf(pileCards(s, target));
  if (top === undefined) return true; // any single card to an empty column
  return buildsOn(card(s, bottom), card(s, top));
}

export const fortyThieves: VariantRules = {
  id: 'forty-thieves',
  columns: [4, 4, 4, 4, 4, 4, 4, 4, 4, 4],
  foundations: 8,
  cells: 0,
  decks: 2,
  suits: ['c', 's', 'd', 'h'],
  variableSuits: 0,
  turn: 1,
  hasWaste: true,
  recycle: false,
  allFaceUp: true,
  autoMove: true,
  foundationToTableau: true,
  canLift,
  canDrop,
  foundationFor: standardFoundationFor,
  buildsOn,
  completedRun: () => false,
};
